import { getUser } from '../../modules/contexts/Auth/RequireAuth';
import httpClient, { isHttpError } from '../httpClient';
//Busca todos os Logs Ações por id usuario
export async function getLogsAcoes() {
  try {
    const user = getUser();
    const userID = user.sub;

    const response = await httpClient.get(`/api/logacoes/user/${userID}`);

    // Verifica se a resposta da API contém o array `logsAcoes`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.logsAcoes)) {
      return response.data.logsAcoes;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de Logs Acoes:', error);
    throw new Error('Erro ao obter lista de Logs Acoes: ' + error);
  }
}
//Busca todos os Logs Ações
export async function getAllLogsAcoes() {
  try {
    const response = await httpClient.get(`/api/logacoes`);

    // Verifica se a resposta da API contém o array `logsAcoes`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.logsAcoes)) {
      return response.data.logsAcoes;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de Logs Acoes:', error);
    throw new Error('Erro ao obter lista de Logs Acoes: ' + error);
  }
}

export async function logExportacaoDados(
  fkUsuario: number,
  entidade: string,
  interfaceSisAf = 1,
  tipoAcao = 5, // Valor padrão
  dataAcao: Date = new Date(), // Valor padrão
) {
  try {
    const response = await httpClient.post(`/api/logacoes/exportardados`, {
      fkUsuario,
      dataAcao: dataAcao.toISOString(),
      interfaceSisAf,
      tipoAcao,
      entidade,
    });

    console.log('Log de exportação registrado com sucesso.', response.data);
  } catch (error) {
    if (isHttpError(error)) {
      // Axios-specific error handling
      console.error('Erro Axios:', error.response?.data || error.message);
    } else if (error instanceof Error) {
      // Generic error handling
      console.error('Erro genérico:', error.message);
    } else {
      console.error('Erro desconhecido:', error);
    }

    throw new Error('Erro ao registrar log de exportação.');
  }
}

//Busca todos os Logs Ações
export async function getLogsRegistro(entidade: string, id: number) {
  try {
    const response = await httpClient.get(
      `/api/logacoes/entidade/${entidade}/registro/${id}`,
    );

    // Verifica se a resposta da API contém o array `logsAcoes`
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (Array.isArray(response.data.logsAcoes)) {
      return response.data.logsAcoes;
    } else {
      console.error('Estrutura de dados inesperada:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Erro ao obter lista de Logs Acoes:', error);
    throw new Error('Erro ao obter lista de Logs Acoes: ' + error);
  }
}
